export default {
  headers: {
    expedient: 'Expediente',
    description: 'Acordo',
    amount: 'Valor Disponivel'
  }
}